import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconWatchStyle0 = gravityIconIndividualCss;

const GravityIconWatch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'eb1059d2b5854df54b146a64f2dbbfc7ff50c579', color: this.color, size: this.size }, h("svg", { key: '816c501f170f5fbad5af0f544b92574b4a4d9449', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '938253e2f0a5fb1bf7ac50c115ba353f2868ab28', d: "m10.37 11.43 3 3a.48.48 0 0 0 .67 0l.36-.35a.51.51 0 0 0 0-.71l-2.68-2.68V6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.57a.49.49 0 0 0 .15.36Z", fill: "currentColor" }), h("path", { key: '3b464d9413cbdc1ceb8b7d46e7b2cfc4813f06ea', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z", fill: "currentColor" }))));
    }
};
GravityIconWatch.style = GravityIconWatchStyle0;

export { GravityIconWatch as gravity_icon_watch };

//# sourceMappingURL=gravity-icon-watch.entry.js.map